module.exports = __webpack_public_path__ + "static/media/ada.a25ebc58.webp";